import React from 'react'

import influencerData from '../../data-influencer/power'
import PageBuilder from '../PageBuilder'
import PageLayout from './PageLayout'

const Power = () => (
    <PageBuilder influencerData={influencerData}>
        <PageLayout />
    </PageBuilder>
)

export default Power
